import { all, call, cancelled, put, select, takeLatest, takeEvery } from 'redux-saga/effects';

import { FETCH_RATES, UPDATE_RATE } from './constants';
import {
    fetchRatesStarted,
    fetchRatesSucceeded,
    fetchRatesFailed,
    fetchRatesCancelled,
    updateRateStarted,
    updateRateSucceeded,
    updateRateFailed,
} from './actions';

import session from 'containers/App/session';
import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { statsService } from 'utils/api';

function* fetchRatesSaga(action) {
    try {
        const { params } = action;
        const { propertyId, start, end, includeMissing = false } = params;
        yield put(fetchRatesStarted(params));

        const token = yield select(session.selectors.selectUserToken);
        const { response, error } = yield call(
            withApiErrorHandling,
            statsService({ token, propertyId }).getSellingRates,
            { start, end, includeMissing },
        );
        if (response) {
            yield put(fetchRatesSucceeded(response.data));
        } else {
            yield put(fetchRatesFailed(error));
        }
    } catch (error) {
        yield put(fetchRatesFailed(error));
    } finally {
        if (yield cancelled()) yield put(fetchRatesCancelled());
    }
}

function* updateRateSaga(action) {
    try {
        const { params } = action;
        const { propertyId, type } = params;
        yield put(updateRateStarted(params));

        const token = yield select(session.selectors.selectUserToken);

        let response;
        let error;
        if (type === 'update') {
            ({ response, error } = yield call(
                withApiErrorHandling,
                statsService({ token, propertyId }).updateSellingRates,
                params.inventory,
            ));
        } else if (type === 'retry') {
            ({ response, error } = yield call(
                withApiErrorHandling,
                statsService({ token, propertyId }).retrySellingRateUpdate,
                { stayDate: params.date },
            ));
        } else if (type === 'cancel') {
            ({ response, error } = yield call(
                withApiErrorHandling,
                statsService({ token, propertyId }).cancelSellingRateUpdate,
                { stayDate: params.date },
            ));
        }
        if (response) {
            yield put(updateRateSucceeded(response.data));
        } else {
            yield put(updateRateFailed(error));
        }
    } catch (error) {
        yield put(updateRateFailed(error));
    }
}

function* sagaWatcher() {
    yield all([takeLatest(FETCH_RATES, fetchRatesSaga), takeEvery(UPDATE_RATE, updateRateSaga)]);
}

export default sagaWatcher;
export { fetchRatesSaga, updateRateSaga };
